/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

/**
 * Enum representing form interaction modes.
 * Defines whether a form is for creating new records, modifying existing ones, or read-only viewing.
 * Controls form validation, field enabling, and submission behavior.
 */
export enum FormActionType {
  NEW,
  MODIFY,
  READ_ONLY,
}

/**
 * Type for select/dropdown option items.
 * Contains label for display and value for form submission.
 */
export type SelectArrayType = {
  label: string;
  value: string;
};

/**
 * Type for autocomplete component options.
 * Contains optional ID for value tracking and label for display text.
 */
export type AutoCompleteOption = {
  id?: string;
  label: string;
};

/**
 * Enum for activity log action color coding.
 * Maps user actions to color identifiers for visual distinction in audit logs.
 * Supports ISO-27001 compliance with visual activity tracking.
 */
export enum ActionLogColors {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  EDIT = 'EDIT',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  FAILED_LOGIN = 'FAILED_LOGIN',
}